import { render, staticRenderFns } from "./SearchVolumeSummary.vue?vue&type=template&id=09b1036e&lang=pug"
import script from "./SearchVolumeSummary.js?vue&type=script&lang=js&external"
export * from "./SearchVolumeSummary.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports